import { api } from '../lib/api'

export type ProfessionRow = { id: number; name: string; email: string; rut: string | null; phone: string | null; profession_title: string; schedule_path: string }

export type ProfessionOption = { id: number; title: string }

export type ProfessionalsIndex = {
  professionals: ProfessionRow[]
  /** Null when the centre is on no plan at all, which is what hides the count line. */
  max_professionals: number | null
  plan_path: string
  agenda_path: string
  new_path: string
}

export type NewProfessional = { professions: ProfessionOption[]; default_profession_id: number }

export type ProfessionalAttributes = {
  rut: string
  name: string
  email: string
  phone: string
  password: string
  password_confirmation: string
  profession_id: number
}

export function fetchProfessionals(healthCenterId: number): Promise<ProfessionalsIndex> {
  return api.get<ProfessionalsIndex>(`/health_centers/${healthCenterId}/professionals.json`)
}

export function fetchNewProfessional(healthCenterId: number): Promise<NewProfessional> {
  return api.get<NewProfessional>(`/health_centers/${healthCenterId}/professionals/new.json`)
}

export function createProfessional(
  healthCenterId: number,
  professional: ProfessionalAttributes,
): Promise<{ redirect: string; notice: string }> {
  return api.post<{ redirect: string; notice: string }>(`/health_centers/${healthCenterId}/professionals.json`, { professional })
}
